import { observable, action, makeObservable } from 'mobx';
import * as surveyTemplateService from 'src/api/surveyTemplate';
import { createContext } from 'react';

export interface SurveyTemplate {
    surveyTemplateVersionId: string;
    surveyTemplateId: string;
    surveyTemplateVersion: number;
    surveyTemplateName: string;
    surveyTemplateDescription?: string;
    surveyTemplateDefinition: {};
    surveyTemplateConfiguration: {};
    surveyTemplateStateCode: string;
    surveyTemplateStateDescription: string;
    createdAt: Date;
    updatedAt: Date;
    auditVersion: number;
}

export interface SurveyTemplateDefinition {
    fields: Field[];
}

export interface Field {
    id: string;
    name: string;
    type: string;
    title: string;
    options: FieldOption[];
    active: boolean;
}

export interface FieldOption {
    label: string;
    value: string;
}

export enum SurveyStatus {
    Published = 'PUBLISHED',
    Draft = 'DRAFT',
    Unpublished = 'UNPUBLISHED',
}

class SurveyStore {
    @observable surveyTemplates: SurveyTemplate[] = [];
    @observable totalSurveyTemplateCount: number = 0;

    constructor() {
        makeObservable(this);
    }

    @action
    reset() {
        this.surveyTemplates = [];
    }

    @action
    async getSurveyTemplates(force = false) {
        if (!force && this.surveyTemplates.length > 0) {
            return;
        }

        const { result, count } = await surveyTemplateService.getSurveyTemplates();
        this.setSurveyTemplates(result || [], count);
    }

    @action
    setSurveyTemplates(surveyTemplates: SurveyTemplate[], total: number = 0) {
        this.surveyTemplates = surveyTemplates;
        this.totalSurveyTemplateCount = total;
    }
}
export const SurveyStoreObject = new SurveyStore();

export default createContext(SurveyStoreObject);
